import React from "react"

import BrokerGuidancePanel from "./BrokerGuidancePanel"
import {
  ChecklistRow,
  GuidanceAccordionBody,
  GuidanceBlock,
  GuidanceIntro,
} from "./ibkrGuidanceShared"

export interface TradingViewBacktestGuidanceProps {
  compact?: boolean
  /** When false, omit Tessera account-name copy (demo has no account chrome). */
  showAccountNotes?: boolean
}

const TradingViewBacktestGuidance = ({
  compact = false,
  showAccountNotes = true,
}: TradingViewBacktestGuidanceProps): React.ReactElement => {
  return (
    <BrokerGuidancePanel
      title="How to export TradingView Strategy Tester trades"
      compact={compact}
      collapsible
    >
      <GuidanceAccordionBody>
        <GuidanceIntro className="!mb-0">
          Export Strategy Tester trades as CSV, then upload the file here.
        </GuidanceIntro>

        <GuidanceBlock title="Export steps">
          <ChecklistRow className="!mb-0">
            Open Strategy Tester → List of trades → Export CSV
          </ChecklistRow>
          <ChecklistRow className="!mb-0">
            The file must include columns such as Trade #, Type, Date and time, Price, and Position
            size
          </ChecklistRow>
        </GuidanceBlock>

        <GuidanceBlock title="In Tessera">
          {showAccountNotes ? (
            <ChecklistRow className="!mb-0">
              Use Account name to label this backtest. Choose Add new account for a separate
              backtest, or pick an existing account only when you want to merge more trades into
              that same label.
            </ChecklistRow>
          ) : null}
          <ChecklistRow className="!mb-0">
            Match Instrument and chart timezone to your TradingView chart. A wrong timezone shifts
            every entry and exit time.
          </ChecklistRow>
        </GuidanceBlock>
      </GuidanceAccordionBody>
    </BrokerGuidancePanel>
  )
}

export default TradingViewBacktestGuidance
